<script>
import talkListMixin from './talk-list-mixin.js'

export default {
  mixins: [talkListMixin],
  props: {
    eventShortName: {type: String},
    events: {type: Array, required: true},
  },

  data() {
    return {
      gridGapSizePx: 125,
      timelineEleHeight: 110,
      showModal: false,
      modalEvent: {},
    }
  },

  computed: {
    getDays: function () {
      const r = {}
      this.events.map((event) => {
        let dateStr = new Date(event.start_datetime).toDateString()
        if (r.hasOwnProperty(dateStr)) {
          if (r[dateStr].length) {
            r[dateStr].push(event)
          } else {
            r[dateStr] = [event]
          }
        } else {
          r[dateStr] = [event]
        }
      })
      return r
    },

    calTimelineVisible: function () {
      const firstEvent = this.events.sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime))[0]
      const lastEvent = this.events.sort((a, b) => new Date(b.end_datetime) - new Date(a.end_datetime))[0]
      let now = new Date()
      let first = new Date(firstEvent.start_datetime)
      let last = new Date(lastEvent.end_datetime)
      return first <= now && now <= last
    },

    locations() {
        let ids = []
        let usedLocations = []
        for (const ev of this.events) {
            if (ids.indexOf(ev.location.id) >= 0) continue
            ids.push(ev.location.id)
            usedLocations.push(ev.location)
        }
        usedLocations.sort((a, b) => a.name.localeCompare(b.name))
        return usedLocations
    },
  },

  methods: {

    speakerFullName: function (speaker) {
      return [speaker.title, speaker.first_name, speaker.last_name].join(' ').trim()
    },

    parseDate: function (datetimeStr, locale = 'de') {
      const opts = {
        year: "numeric",
        month: "short",
        day: "numeric",
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    displayTime(datetimeStr, locale = 'de') {
      const opts = {
        hour: "numeric",
        minute: "numeric"
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    eventIntervalBlocks: function (event) {
      let delta = new Date(event.end_datetime) - new Date(event.start_datetime)
      return delta / 1000 / 60 / 30
    },

    eventPaddingBlocks: function (event, eventDayKey) {
      let start = new Date(this.getDays[eventDayKey][0].start_datetime)
      let delta = new Date(event.start_datetime) - start
      return delta / 1000 / 60 / 30
    },

    getDayInterval: function (day) {
      let start = new Date(this.events[0].start_datetime)

      let endEvent = this.getDays[day].reduce(function (prev, curr) {
        return new Date(prev.end_datetime) > new Date(curr.end_datetime) ? prev : curr;
      })
      let end = new Date(endEvent.end_datetime)

      const timeIntervals = [];
      for (let time = start; time <= end; time.setMinutes(time.getMinutes() + 30)) {
        timeIntervals.push(new Date(time));
      }
      return timeIntervals;
    },

    calGridStyle: function (eventDayKey) {
      let height = this.locations.length + 1
      return {
        width: this.getDayInterval(eventDayKey).length * this.gridGapSizePx + 25 + 'px',
        'background-image': 'repeating-linear-gradient(to right, #ccc 0 1px, transparent 1px 100%)',
        'background-size': `${this.gridGapSizePx}px ${this.gridGapSizePx}px`,
        position: 'relative',
        height: this.timelineEleHeight * height + 'px',
      }
    },

    calTimelineDelta: function (date, eventDayKey) {
      let start = new Date(this.getDays[eventDayKey][0].start_datetime)
      let delta = date - start
      return delta / 1000 / 60 / 30
    },

    calTimelineStyle: function (eventDayKey) {
      // let date = new Date('2022-09-13T09:00:00+00:00')
      let date = new Date()
      return {
        position: 'absolute',
        'border-left': '4px solid red',
        color: 'white',
        height: '100%',
        top: '-.5rem',
        left: this.calTimelineDelta(date, eventDayKey) * this.gridGapSizePx + 'px',
        overflow: 'hidden',
      }
    },

    calTimelineEleStyle: function (event, eventDayKey) {
      let locPos = this.locations.map(e => e.id).indexOf(event.location.id)
      if (locPos === -1) {
        locPos = (this.locations.length || 0) + 1
      }

      return {
        position: 'absolute',
        background: event.streams.length ? event.streams[0].color : "#0082be",
        color: 'white',
        height: this.timelineEleHeight - 10 + 'px',
        padding: '5px',
        cursor: 'pointer',
        width: this.eventIntervalBlocks(event) * this.gridGapSizePx + 'px',
        top: this.timelineEleHeight * locPos + 'px',
        left: this.eventPaddingBlocks(event, eventDayKey) * this.gridGapSizePx + 'px',
        overflow: 'hidden'
      }
    },

    parseTitleDate: function (eventDayKey) {
      let date = new Date(eventDayKey)
      let lang = 'de'
      if (typeof window !== 'undefined') {
        lang = window.navigator.language
      }

      return date.toLocaleDateString(lang, {day: 'numeric', month: 'short', year: '2-digit'})
    },

    toggleModal: function (event = undefined) {
      this.showModal = !this.showModal
      let bodyEle = document.getElementsByTagName('body')[0]
      if (this.showModal) {
        this.modalEvent = event
        bodyEle.style.overflow = 'hidden'
      } else {
        bodyEle.style.overflow = 'unset'
        this.modalEvent = undefined
      }
    },

    cssSettings: function(event) {
      let info = {}
      info['fav-border'] = this.getFavorites().includes(event.content_code)
      return info
    }
  },

}
</script>

<template>
<div style="margin-bottom: 5rem" class="c-timetable-wrapper">
  <toast v-if="toastMessage" :message="toastMessage" @closed="toastMessage=''"/>
  <div style="display: flex; flex-direction: row; padding-bottom: 15px">

    <div style="border-right: 3px dashed black; max-width:15vw"
     class="flex-shrink-0 c-location-wrapper">
      <div v-for="loc in locations" :key="loc.id" class="overflow-hidden"
           :style="{
                paddingTop: '2rem',
                paddingRight: '1rem',
                width: 'auto',
                height: timelineEleHeight + 'px',
               }"
      >
        <div class="font-weight-bold d-flex align-items-center"
         style="height: 100%;font-size:90%">
          {{ loc.name }}
        </div>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; column-gap: .5rem; overflow-x: scroll; padding-bottom: 15px">
      <div
          v-for="(value, key, index) in getDays" :key="index" style="padding-left: 25px; height: 100%;"
          :style="{'border-left': index !== 0 ? '3px dashed black' : ''}"
      >
        <div class="mb-2">
          <div style="display: flex; flex-direction: row;">
            <div v-for="(int, i) in getDayInterval(key)" :style="{width: gridGapSizePx + 'px', overflow: 'hidden'}">
              {{ int.getMinutes() === 0 ? int.getHours()+'Uhr' : '' }}
            </div>
          </div>
        </div>


        <div :style="calGridStyle(key, value.length)">
          <!--div v-if="calTimelineVisible" name="currentTimeLine" :style="calTimelineStyle(key)">&nbsp;</div-->
          <div
              @click="toggleModal(event)"
              class="timeline-element"
              :class="cssSettings(event)"
              v-for="(event, i) in value" :key="event.id"
              :style="calTimelineEleStyle(event, key, i)"
              :title="event.title"
          >
            <!--i v-if="getFavorites().includes(event.content_code)" class="float-end fas fa-star"></i-->
            <h5 class="mb-0">{{displayTime(event.start_datetime)}}-{{displayTime(event.end_datetime)}}</h5>
            <div class="font-weight-bold" :style="{overflow: 'hidden',
              '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
                    'text-overflow': 'ellipsis'}">{{event.title}}</div>
            <div class="small" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              {{event.speakers.flatMap(obj => obj.first_name+' '+obj.last_name).join(', ')}}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
<!-- Modal -->
<div
    v-if="showModal"
    style="z-index: 999; left: 0; top: 0; width: 100%; height: 100%; position: fixed; background: rgba(0,0,0, 0.75); visibility: hidden"
    :style="{visibility: showModal ? 'unset' : undefined}"
>
  <div style="display: flex;
  align-items: center;
  justify-content: center; height: 100%">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{ modalEvent.location.name }} Session</h3>
          <button type="button" class="close" @click="toggleModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <talk-detail :talk="modalEvent" :language-display="false"
           @favorite-changed="onFavoriteChanged($event)" @stream="$emit('stream', $event)" @speaker-click="toggleModal" />
        </div>

        <div class="modal-footer">
          <button @click="toggleModal" type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
</template>

<style scoped>
.timeline-element:hover {
  background: rgba(0, 0, 0, 1) !important;
}

h5 {
  font-weight: bold;
}

.fav-border {
  border: 3px solid yellow;
}

</style>